import { CardInfoUserChannel } from 'components/Sidemenu/SideMenuInChat/components'
import React, { useState } from 'react'
import './styles.scss'
import ModalDelete from 'components/ModalDelete'
import { lang } from 'utils/helpers'
import { useHistory } from 'react-router-dom'
import { clearReduxExitChannel } from '../utils'

const Members = ({ conversation, conversationAction, operatorId, dispatch, toggleOpen, tabs, isGroup }) => {
  const [modalRemove, setModalRemove] = useState(false)
  const [idRemove, setIdRemove] = useState('')
  const [messageError, setMessageError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const history = useHistory()

  const handleRemoveModal = (id) => {
    setModalRemove(state => !state)
    setIdRemove(id)
  }

  const handleRemoveUser = async () => {
    setIsSubmitting(true)
    conversationAction({
      type: 'kick',
      conversationId: conversation._id,
      conversationType: conversation.type,
      userIds: [idRemove]
    }).then(() => {
      handleRemoveModal('')
      if(operatorId === idRemove){
        clearReduxExitChannel(dispatch, conversation, history, toggleOpen, tabs)
      }
      clearStates()
    }).catch(() => {
      setIsSubmitting(false)
    })
  }

  const clearStates = () => {
    setIdRemove('')
    setMessageError('')
    setIsSubmitting(false)
  }

  return (
    <div className='inchat-members-container'>
      {conversation.usersInfo.map(user => (
        <CardInfoUserChannel
          key={user._id}
          user={user}
          classNameAvatar={'inchat-members-container__image'}
          isRemoved={user._id === conversation.createdBy}
          handleRemoveModal={handleRemoveModal}
          className={isGroup ? 'inchat-members-container__card-user' : ''}
          sizeAvatar={48}
          buttonsActions={!isGroup}
        />
      )
      )}
      <ModalDelete
        isOpen={modalRemove}
        toggle={() => {
          setModalRemove(state => !state)
          clearStates()
        }}
        header={lang('dashboard_remove_user_title')}
        text1={lang('dashboard_remove_user_questions')}
        text2={lang('dashboard_remove_user_legend')}
        event={handleRemoveUser}
        isSubmitting={isSubmitting}
        textBtn1={lang('dashboard_remove')}
        errorMessage={messageError}
      />
    </div>
  )
}

export default Members